import { ReactNode } from 'react'

type AdminListLayoutProps = {
  title: string
  isLoading: boolean
  error?: string | null
  onRefresh: () => void
  filters: ReactNode
  emptyMessage?: string
  listContent: ReactNode
}

const AdminListLayout = ({
  title,
  isLoading,
  error,
  onRefresh,
  filters,
  emptyMessage = 'No items found',
  listContent,
}: AdminListLayoutProps) => {
  return (
    <div className="flex flex-col h-screen -m-6 p-6 overflow-hidden">
      <h1 className="mb-4 text-2xl font-bold">{title}</h1>

      {filters}

      {error && (
        <div className="alert alert-error mb-4">
          <div>
            <span>{error}</span>
            <button className="btn btn-sm" onClick={onRefresh}>
              Retry
            </button>
          </div>
        </div>
      )}

      <div className="overflow-hidden">
        {isLoading && (
          <div className="flex justify-center p-8">
            <span className="loading loading-spinner loading-lg"></span>
          </div>
        )}

        {!isLoading && !listContent && (
          <div className="rounded-box border border-base-300 bg-base-100 p-8 text-center">
            <p className="text-sm opacity-70">{emptyMessage}</p>
          </div>
        )}

        {!isLoading && listContent}
      </div>
    </div>
  )
}

export { AdminListLayout }
